import { render, staticRenderFns } from "./TreatmentBrowser.vue?vue&type=template&id=1da86c00&"
import script from "./TreatmentBrowser.vue?vue&type=script&lang=js&"
export * from "./TreatmentBrowser.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentBrowser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports